import { Grid, Card, CardMedia, CardContent, Typography, CardActions, Button, Box } from '@mui/material';

export interface AppAsset {
  src: string;
  alt: string;
}

export interface ImagesProps {
  images: AppAsset[];
}

export const Images: React.FC<ImagesProps> = ({ images }) => (
  <Box>
    <Card
      sx={{
        py: 2,
        px: 6,
      }}
    >
      <Typography align="center" variant="h5" gutterBottom>
        Imagens
      </Typography>
      <hr />

      <Grid container spacing={2}>
        {images.map(({ alt, src }, index) => (
          <Grid item key={alt} xs={12} sm={6} md={4}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                mt: 2,
              }}
            >
              <CardMedia component="div" sx={{ pt: '56.25%' }} image={src} />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="h5" component="h2">
                  {`Imagem 0${index + 1}`}
                </Typography>
                <Typography>{alt}</Typography>
              </CardContent>
              <CardActions>
                <Button size="small" disabled>
                  View
                </Button>
                <Button size="small" disabled>
                  Edit
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Card>
  </Box>
);
